import { render } from "./Wangdian.vue?vue&type=template&id=6a3265f2"
import script from "./Wangdian.vue?vue&type=script&lang=js"
export * from "./Wangdian.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__